import React from "react"
import {useDndContext, useDroppable, DragOverlay} from "@dnd-kit/core"
import {Grid, Typography, Box, styled} from "@mui/material"
import PropTypes from "prop-types"
import DraggableItemComponent from "./DraggableItemComponent"
import ItemVisual from "./ItemVisual"
import DraggableCreateButton from "./DraggableCreateButton"
import {getImageForPath} from "../../../../anwendungskonfigurator/misc/utils"

const ITEM_SIZE = 64
const BOARD_ID = "drop-board"

const StyledGrid = styled(Grid)(({theme}) => theme.WELTBOARD.LayerContainer)
const StyledSelectArea = styled(Box)(({theme}) => theme.WELTBOARD.SelectArea)
const BoardArea= styled(Box)(({theme}) => theme.WELTBOARD.BoardArea)
const ItemWrapper= styled(Box)(({theme}) => theme.WELTBOARD.ItemWrapper)

const WeltBoardLayer = ({items = [], widget, triggerAction}) => {
    const {setNodeRef} = useDroppable({id: BOARD_ID})
    const {active} = useDndContext()
    const objekte = widget.objekte?.origin.children

    let overlayType = null
    if (active) {
        if (active.data.current?.isCreator) {
            overlayType = active.data.current.type
        } else {
            const activeItem = items.find((i) => i.id === active.id)
            if (activeItem) overlayType = activeItem.type
        }
    }

    return (
        <StyledGrid
            container
            direction="column">
            <StyledSelectArea
                sx={{}}>
                <Typography
                    variant="h6"
                    sx={{mb: 1}}>
                    {widget.text}
                </Typography>
                <Box sx={{display: "flex", gap: 1}}>
                    {objekte?.map((objekt) => (
                        <DraggableCreateButton objekt={objekt} />
                    ))}
                </Box>
            </StyledSelectArea>

            <BoardArea>
                <ItemWrapper
                    id={BOARD_ID}
                    ref={setNodeRef}
                    style={{
                        backgroundImage: `url("${getImageForPath(widget.background)}")`,
                       
                    }}>
                    {items.map((item) => (
                        <DraggableItemComponent
                            key={item.id}
                            item={item}
                            objekte={objekte}
                            triggerAction={triggerAction}
                            isDragging={active?.id === item.id}
                        />
                    ))}
                </ItemWrapper>
            </BoardArea>

            {/* Globales Overlay */}
            <DragOverlay
                dropAnimation={null}
                zIndex={100}>
                {overlayType ? (
                    <div
                        style={{
                            width: ITEM_SIZE,
                            height: ITEM_SIZE,
                            opacity: 0.8,
                            cursor: "grabbing",
                        }}>
                        <ItemVisual
                            objekte={objekte}
                            type={overlayType}
                            triggerAction={triggerAction}
                        />
                    </div>
                ) : null}
            </DragOverlay>
        </StyledGrid>
    )
}

WeltBoardLayer.propTypes = {
    items: PropTypes.array.isRequired,
}

export default WeltBoardLayer
